<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.autonomous_teaching_activity.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 3 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
      :state="validateState('description')"
    >
      <div
        class="form-description mb-2"
        :class="{ 'is-invalid': validateState('description') === false }"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="autonomous_teaching_activity.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="autonomous_teaching_activity"
        :content_rich_text="autonomous_teaching_activity.description"
        :show_last_modification="true"
        @save="
          (content) => patchDescription(autonomous_teaching_activity, content)
        "
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="autonomous_teaching_activity"
          :Text="autonomous_teaching_activity.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback
        id="input-description-live-feedback"
        :state="validateState('description')"
      >
        {{ $t("reusable.common.required") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(autonomous_teaching_activity.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2 mb-2"
    >
      <ModificationDate
        :Information="autonomous_teaching_activity"
      ></ModificationDate>
    </b-form-group>

    <div class="row">
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="mr-1" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
export default {
  name: "AutonomousTeachingActivityForm",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  mixins: [validationMixin],
  props: {
    AutonomousTeachingActivity: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          creation_date: null,
          created_by: null,
          update_date: null,
          updated_by: null,
        };
      },
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      autonomous_teaching_activity: { ...this.AutonomousTeachingActivity },
    };
  },
  validations: {
    autonomous_teaching_activity: {
      name: {
        required,
        minLength: minLength(3),
      },
      description: {
        required,
        minLength: minLength(5),
      },
    },
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.autonomous_teaching_activity[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.autonomous_teaching_activity.$touch();
      if (this.$v.autonomous_teaching_activity.$anyError) {
        return;
      }
      if (isNaN(this.autonomous_teaching_activity.id)) {
        this.createAutonomousTeachingActivity();
      } else this.updateAutonomousTeachingActivity();
    },
    patchDescription(object, text) {
      this.autonomous_teaching_activity.description = text;
    },
    createAutonomousTeachingActivity() {
      this.$store
        .dispatch(
          names.POST_AUTONOMOUS_TEACHING_ACTIVITY,
          this.autonomous_teaching_activity
        )
        .then((response) => {
          toast(
            this.$getVisibleNames(
              "mesh.autonomousteachingactivity",
              false,
              "Actividad de Trabajo Autónomo"
            ) +
              " " +
              this.$t("reusable.common.created")
          );
          this.$emit("created", response);
        });
    },
    updateAutonomousTeachingActivity() {
      this.$store
        .dispatch(
          names.UPDATE_AUTONOMOUS_TEACHING_ACTIVITY,
          this.autonomous_teaching_activity
        )
        .then((response) => {
          toast(
            this.$getVisibleNames(
              "mesh.autonomousteachingactivity",
              false,
              "Actividad de Trabajo Autónomo"
            ) +
              " " +
              this.$t("reusable.common.updated")
          );
          this.$emit("updated", response);
        });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description.is-invalid {
  border-color: #dc3545;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>